<code class="font-mono text-[12px] break-words whitespace-pre-wrap">
  @if (segments(); as parts) {
    @for (part of parts; track $index) {
      <span [class]="ROLE_CLASSES[part.role]">{{ part.text }}</span>
    }
  } @else {
    <span>{{ text() }}</span>
  }
</code>
